import { parseCookies } from 'nookies'

import styles from './styles.module.scss'

const User = () => {
  const { profileImageURL, email, name } = parseCookies()

  return (
    <div className={styles.container}>
      <div>
        {profileImageURL ? <img src={profileImageURL} alt={name} /> : name?.[0]}
      </div>
      <div className={styles.principalInfos}>
        <span>
          {email?.split('@')[0]}
          <br />
          <small>@{email?.split('@')[1]}</small>
        </span>
      </div>
    </div>
  )
}

export default User
